module.exports = __webpack_public_path__ + "img/cbd-leaf-small.6c5609b4.png";